import { customContextFactory } from '../../../hooks';
import { ScheduleEventAppointmentInfo } from '../../schedule-calendar-components/helpers';

export type ApptPanelContextType = {
  locationId: string;
  apptDetails?: ScheduleEventAppointmentInfo;
  isV3Enabled: boolean;
  isIntegratedOffice: boolean;
  shouldShowOperatory: boolean;
};

export const [ApptPanelContextProvider, useApptPanelContext] = customContextFactory<ApptPanelContextType>();
